import { useRollbar } from "@rollbar/react"
import { useEffect } from "react"
import { useRouteError } from "react-router"

import type { ParsedErrorType } from "@/api"
import { ServerError } from "@/api"

import NotFound from "./notFound"
import Server from "./server"

function Error() {
  const rollbar = useRollbar()

  const error = useRouteError() as Error | ParsedErrorType

  useEffect(() => {
    rollbar.error(error as Error)
  }, [error, rollbar])

  if (error instanceof ServerError) {
    if (error.statusCode === 404 && error.error_type === "client_error") {
      return <NotFound />
    }
  }

  return <Server error={error} />
}

export default Error
